import { render, staticRenderFns } from "./WallpaperSharing.vue?vue&type=template&id=042fece1&scoped=true&"
import script from "./WallpaperSharing.vue?vue&type=script&lang=ts&"
export * from "./WallpaperSharing.vue?vue&type=script&lang=ts&"
import style0 from "./WallpaperSharing.vue?vue&type=style&index=0&id=042fece1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042fece1",
  null
  
)

export default component.exports